import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import "./../custom.css";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import { getFinancialYearList, getFinancialYearListNew } from "../../../core/common/financialYear";

const PmsReviewHod = () => {
  const params = useParams();
  const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (finYearData?.data?.fin_year) {
      setFinance_year(finYearData.data.fin_year);
    }
  }, [finYearData]);
  const [managerRatingData, setManagerRatingData] = useState<any>({});
  const [sameAsChecked, setSameAsChecked] = useState(false);
  const pmsEmpId = localStorage.getItem("PmsEmpID");
  const [count, setCount] = useState(1);
  const [activetab, setActivetab] = useState<any>("kra");
  const [kraDetailsData, setKraDetailsData] = useState<any>([]);
  const [behaDetailsData, setBehaDetailsData] = useState<any>([]);
  const [potentialData, setPotentialData] = useState<any>([]);
  const [ratingData, setRatingData] = useState<any>([]);
  const [comaspiDetailsData, setComaspiDetailsData] = useState<any>({});
  const routes = all_routes;

  const [recommendationData, setRecommendationData] = useState<any>({
    type_id: "",
    justification: "",
    from_location_id: "",
    to_location_id: "",
    from_designation_id: "",
    to_designation_id: "",
    increment_percent: "",
  });

 const ratingOptions = [
    { value: "OS", label: "Outstanding (OS)" },
    { value: "VG", label: "Very Good (VG)" },
    { value: "G", label: "Good (G)" },
    { value: "AVG", label: "Average (Avg)" },
    { value: "P", label: "Poor (P)" },
  ];
  const ratingBehaiviroul = [
    { value: "P", label: "L1" },
    { value: "AVG", label: "L2" },
    { value: "G", label: "L3" },
    { value: "VG", label: "L4" },
    // { value: "OS", label: "L5" },
  ];

  const tabs = [
    { value: "kra", label: "KRA 80%" },
    { value: "Potential", label: "Potential 20%" },
    { value: "Overall Comments", label: "Overall Comments" },
  ];

  const {
    data: getkradetails,
    loading: kradetailsLoading,
    error: kradetailsError,
  } = useApi("/api/get-kra-appraisal-hod", {
    method: "POST",
    payload: {
      employee_id: params?.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });

  const {
    data: getPotentialdetails,
    loading: PotentialdetailsLoading,
    error: PotentialdetailsError,
  } = useApi("/api/get-hod-potensial-appraisal", {
    method: "POST",
    payload: {
      employee_id: params?.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });
  const {
    data: getRatingdetails,
    loading: RatingdetailsLoading,
    error: RatingdetailsError,
  } = useApi("/api/get-rating", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getcomaspidetails,
    loading: comaspidetailsLoading,
    error: comaspidetailsError,
  } = useApi("/api/get-overall-comments-hod", {
    method: "POST",
    payload: {
      employee_id: params?.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });

  const {
    data: getPMSStatusManager,
    loading: PMSStatusManagerLoading,
    error: PMSStatusManagerError,
  } = useApi("/api/get-hod-pms-status", {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });

  const {
    data: getPMStotalRating,
    loading: PMStotalRatingLoading,
    error: PMStotalRatingError,
  } = useApi("/api/get-hod-pms-rating", {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });

  const {
    data: getRecommendationType,
    loading: RecommendationTypeLoading,
    error: RecommendationTypeError,
  } = useApi("/api/get-recommendation-type", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getworkLocatation,
    loading: workLocatationLoading,
    error: workLocatationError,
  } = useApi("/api/get-workLocatation", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: profileResponse,
    error: profileResponseError,
    loading: profileResponseLoading,
  } = useApi(`/api/get-employee-details/${params.employee_id}`, {
    method: "GET",
    autoCall: true,
  });

  const {
    data: upperDesignations,
    error: upperDesignationsError,
    loading: upperDesignationsLoading,
  } = useApi(`/api/get-employee-upper-designations/${params.employee_id}`, {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getRecomandations,
    error: getRecomandationsError,
    loading: getRecomandationsLoading,
  } = useApi(`/api/get-Recomandations-employee-hod`, {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
  });

  const {
    data: getstatus,
    loading: statusLoading,
    error: statusError,
  } = useApi("/api/get-pms-status", {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });

  useEffect(() => {
    if (getPMStotalRating?.success)
      setManagerRatingData(getPMStotalRating?.data);
  }, [getPMStotalRating]);

  useEffect(() => {
    if (getkradetails?.success) setKraDetailsData(getkradetails?.data);
  }, [getkradetails]);

  useEffect(() => {
    if (getcomaspidetails?.success) {
      setComaspiDetailsData(getcomaspidetails?.data);
    }
  }, [getcomaspidetails]);

  useEffect(() => {
    if (getPotentialdetails?.success) {
      setPotentialData(getPotentialdetails?.data);
    }
  }, [getPotentialdetails]);

  useEffect(() => {
    if (getRatingdetails?.success) {
      setRatingData(getRatingdetails?.data);
    }
  }, [getRatingdetails]);

  useEffect(() => {
    if (getRecomandations?.success) {
      const data = getRecomandations.data;

      setRecommendationData((prev: any) => ({
        ...prev,
        ...data,
        from_location_id: profileResponse?.data[0].work_location_id,
        from_designation_id: profileResponse?.data[0].designation_id,
      }));
    }
  }, [getRecomandations]);

  const handleKraChange = (index: number, field: string, value: any) => {
    const updatedData = [...kraDetailsData];
    updatedData[index][field] = value;
    setKraDetailsData(updatedData);
  };

  const handlePotensialChange = (
    categoryIndex: number,
    subcategoryIndex: number,
    field: string,
    value: any,
  ) => {
    const updated = [...potentialData];

    updated[categoryIndex].subcategories[subcategoryIndex][field] = value;

    setPotentialData(updated);
  };

  const getInputdata = (e: any) => {
    console.log(comaspiDetailsData);
    const { name, value } = e.target;
    setComaspiDetailsData({ ...comaspiDetailsData, [name]: value });
  };

  const {
    data: addkraRatingdetails,
    loading: addkraRatingdetailsLoading,
    error: addkraRatingdetailsError,
    callApi: AddRaitingKra,
  } = useApi("/api/add-kra-appraisal-hod", {
    method: "POST",
    autoCall: false,
  });

  const KRASaveDraft = async (e: any) => {
    e.preventDefault();
    const filterData = kraDetailsData.filter(
      (item: any, index: any) => item.rating && item.achievement !== null,
    );

    const ratingData = filterData.map((item: any, index: any) => {
      return {
        rating: item.rating,
        achievement: item.achievement,
        kra_id: item.kra_id,
      };
    });
    const payload = {
      employee_id: params?.employee_id,
      role: "HOD",
      financial_year: finance_year,
      appraisal_data: ratingData,
    };
    try {
      const response = await AddRaitingKra(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addBehaRatingdetails,
    loading: addBehaRatingdetailsLoading,
    error: addBehaRatingdetailsError,
    callApi: AddRaitingBeha,
  } = useApi("/api/manager/add-behavioural-comments", {
    method: "POST",
    autoCall: false,
  });

  const BhaviorSaveDraft = async (e: any, status: any) => {
    e.preventDefault();
    const filterData = behaDetailsData.filter(
      (item: any, index: any) =>
        item.manager_rating && item.manager_comments !== null,
    );
    const goal_id =
      behaDetailsData && behaDetailsData.length > 0
        ? behaDetailsData[0].goal_id
        : null;

    const ratingData = filterData.map((item: any, index: any) => {
      return {
        manager_rating: item.manager_rating,
        manager_comments: item.manager_comments,
        behavioural_id: item.behavioural_id,
      };
    });
    const payload = {
      status: status,
      employee_id: pmsEmpId,
      goal_id: goal_id,
      rating_data: ratingData,
    };
    try {
      const response = await AddRaitingBeha(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addPotensialRatingdetails,
    loading: addPotensialRatingdetailsLoading,
    error: addPotensialRatingdetailsError,
    callApi: AddRaitingPotensial,
  } = useApi("/api/add-hod-potensial-appraisal", {
    method: "POST",
    autoCall: false,
  });

  const PotensialSaveDraft = async (e: any) => {
    e.preventDefault();
    const apprisal_data: any[] = [];

    potentialData.forEach((category: any) => {
      category.subcategories.forEach((sub: any) => {
        if (sub.rating && sub.achievement !== null) {
          apprisal_data.push({
            subcategory_id: sub.id,
            rating: sub.rating,
            achievement: sub.achievement,
          });
        }
      });
    });

    const payload = {
      financial_year: finance_year,
      role: "HOD",
      employee_id: params.employee_id,
      apprisal_data: apprisal_data,
    };
    console.log(payload);
    try {
      const response = await AddRaitingPotensial(payload);

      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addCompAspRatingdetails,
    loading: addCompAspRatingdetailsLoading,
    error: addCompAspRatingdetailsError,
    callApi: AddRaitingCompAsp,
  } = useApi("/api/add-overall-comments-hod", {
    method: "POST",
    autoCall: false,
  });

  const buildRecommendationPayload = () => {
    const rd = recommendationData;
    console.log(recommendationData);
    let recPayload: any = {
      type_id: rd.type_id,
      justification: rd.justification,
    };

    switch (rd.type_id) {
      case "1": // Promotion
        recPayload.from_designation_id = rd.from_designation_id;
        recPayload.to_designation_id = rd.to_designation_id;
        break;

      case "2": // Increment
        recPayload.increment_percent = rd.increment_percent;
        break;

      case "3": // Location Change
        recPayload.from_location_id = rd.from_location_id;
        recPayload.to_location_id = rd.to_location_id;
        break;

      default:
        break;
    }

    return recPayload;
  };

  const validateRecommendation = () => {
    const rd = recommendationData;
    const oc = comaspiDetailsData;
    console.log(oc);
    if (oc.comments === null) return "Please fill the comments.";
    if (!rd.type_id) return "Please select a recommendation type.";

    if (rd.type_id == "1") {
      if (!rd.to_designation_id) return "Please select the new designation.";
    }

    if (rd.type_id == "2") {
      if (!rd.increment_percent) return "Please enter increment percent.";
    }

    if (rd.type_id == "3") {
      if (!rd.to_location_id) return "Please select the new location.";
    }

    return null; // No errors
  };

  const ComAspSaveData = async (e: any) => {
    e.preventDefault();
    const validationError = validateRecommendation();
    if (validationError) {
      Swal.fire({
        title: "Validation Error",
        text: validationError,
        icon: "warning",
      });
      return;
    }
    const recommendations = buildRecommendationPayload();
    const payload = {
      employee_id: params.employee_id,
      financial_year: finance_year,
      role: "HOD",
      carrier_aspiration_comments:
        comaspiDetailsData.skip_manager_carrier_aspiration,
      carrier_aspiration: comaspiDetailsData.ID,
      comments: comaspiDetailsData.comments,
      recommendations,
    };

    console.log(payload);

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once you submit the performance review, you won't be able to make any changes.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }
    try {
      const response = await AddRaitingCompAsp(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const sameAs = (e: any) => {
    const isChecked = e.target.checked;
    if (activetab === "kra") {
      if (isChecked) {
        const updated = kraDetailsData.map((item: any) => ({
          ...item,
          rating: item.r1_rating,
          achievement: item.r1_achievement,
        }));

        setKraDetailsData(updated);
      } else {
        const updated = kraDetailsData.map((item: any) => ({
          ...item,
          rating: item.rating,
          achievement: item.achievement,
        }));

        setKraDetailsData(updated);
      }
    } else if (activetab === "Potential") {
      if (isChecked) {
        const updated = potentialData.map((cat: any) => ({
          ...cat,
          subcategories: cat.subcategories.map((sub: any) => ({
            ...sub,
            rating: sub.r1_rating,
            achievement: sub.r1_achievement,
          })),
        }));
        setPotentialData(updated);
      } else {
        const updated = potentialData.map((cat: any) => ({
          ...cat,
          subcategories: cat.subcategories.map((sub: any) => ({
            ...sub,
            rating: sub.rating,
            achievement: sub.achievement,
          })),
        }));
        setPotentialData(updated);
      }
    }
  };

  const handleRecommendationChange = (e: any) => {
    const { name, value } = e.target;
    setRecommendationData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Performance Review HOD</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">PMS</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Performance Review HOD
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>

                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearListNew(finance_year).map((fy) => (
                    <option key={fy} value={fy}>
                      {fy}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <section className="custom-card">
            <div className="custom-card-header d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                {tabs.map((item, index) => (
                  <button
                    className={`${
                      activetab === item.value
                        ? "btn btn-primary custom_button"
                        : "btn btn-primary tab-button"
                    }`}
                    onClick={() => {
                      setActivetab(item.value);
                      setSameAsChecked(false);
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-3">
                <div>
                  <span
                    className={`badge `}
                    style={{ backgroundColor: "#2e3294" }}
                  >
                    Status : {getstatus?.status}
                  </span>
                </div>

                <button
                  className="btn btn-outline-secondary"
                  data-bs-toggle="modal"
                  data-bs-target={
                    activetab === "Behavioural Competence"
                      ? "#behaviouralinfo"
                      : "#ratinginfo"
                  }
                >
                  <i className="fa fa-users"></i>
                </button>
              </div>
            </div>

            {activetab === "kra" ? (
              <>
                {kraDetailsData && kraDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Smart Goal</th>
                            <th>Target</th>
                            <th>Date</th>
                            <th>File</th>
                            <th>Wt(%)</th>
                            <th>Unit</th>
                            <th>Employee Rating</th>
                            <th>Employee Comments</th>
                            <th>Manager Rating</th>
                            <th>Manager Comments</th>
                            <th>Skip Manager Rating</th>
                            <th>Skip Manager Comments</th>
                            {/* <th>HOD Rating</th>
                            <th>HOD Comments</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {kraDetailsData &&
                            kraDetailsData.map((item: any, idx: any) => {
                              return (
                                <tr key={item.id}>
                                  <td className="allcolor">{idx + 1}</td>
                                  <td className="allcolor">
                                    <p>
                                      <strong>{item.smart_goals}</strong>
                                    </p>
                                    <p>{item.kra_category_name}</p>
                                  </td>
                                  <td className="allcolor">
                                    <ul>
                                      {(() => {
                                        let targets = [];
                                        try {
                                          targets = JSON.parse(item.target);
                                          if (!Array.isArray(targets))
                                            targets = [];
                                        } catch (e) {
                                          console.error(
                                            "Invalid JSON:",
                                            item.target,
                                          );
                                        }

                                        return targets.map(
                                          (targetItem: any, index: any) => (
                                            <li key={index}>
                                              {index + 1}. {targetItem}
                                            </li>
                                          ),
                                        );
                                      })()}
                                    </ul>
                                  </td>

                                  <td className="allcolor">
                                    {item.target_achievement_date}
                                  </td>
                                  <td className="allcolor">
                                    {!item.attachment_url ||
                                    item.attachment_url.endsWith("/null") ? (
                                      "N/A"
                                    ) : (
                                      <a
                                        href={item.attachment_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "blue",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        View
                                      </a>
                                    )}
                                  </td>

                                  <td className="allcolor">{item.weightage}</td>
                                  <td className="allcolor">
                                    <p>{item.unit}</p>
                                  </td>
                                  <td className="allcoloremployee">
                                    <select
                                      className="form-select"
                                      value={item?.employee_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcoloremployee">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea allcoloremployee"
                                      value={item.employee_achievement}
                                      readOnly
                                    />
                                  </td>
                                  <td className="allcolormanager">
                                    <select
                                      className="form-select"
                                      value={item?.r1_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolormanager">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea allcolormanager"
                                      value={item?.r1_achievement}
                                      readOnly
                                    />
                                  </td>
                                  <td className="allcolorskipmanager">
                                    <select
                                      className="form-select"
                                      value={item?.r2_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolorskipmanager">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea-skipmanager allcolorskipmanager"
                                      value={item?.r2_achievement}
                                      readOnly
                                    />
                                  </td>
                                  {/* <td>
                                    <select
                                      className="form-select"
                                      value={item?.rating || ""}
                                      disabled={getPMSStatusManager?.data?.status === "Submit"}
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "rating",
                                          e.target.value,
                                        );
                                      }}
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </td>
                                  <td>
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item?.achievement}
                                      readOnly={getPMSStatusManager?.data?.status === "Submit"}
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "achievement",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </td> */}
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    <div className="p-2 d-flex gap-2 justify-content-end ">
                      <div>
                        <button
                          className="btn btn-primary tab-button"
                          onClick={() => setActivetab("Potential")}
                        >
                          Next
                        </button>
                      </div>
                      {/* {getPMSStatusManager?.data?.status === "Submit" ? null :
                        <div>
                          <button
                            className="btn btn-primary tab-button"
                            onClick={(e: any) => {
                              KRASaveDraft(e);
                            }}
                          >
                            Save as draft
                          </button>
                        </div>
                      } */}
                    </div>
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : activetab === "Behavioural Competence" ? (
              <>
                {behaDetailsData && behaDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Behavioural Competency</th>
                            <th>Description</th>
                            <th>Employee Rating</th>
                            <th>Employee Comments</th>
                            <th>Manager Rating</th>
                            <th>Manager Comments</th>
                            <th>Skip Manager Rating</th>
                            <th>Skip Manager Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {behaDetailsData &&
                            behaDetailsData.map((item: any, idx: any) => {
                              return (
                                <tr key={item.id}>
                                  <td className="allcolor">{idx + 1}</td>

                                  <td className="allcolor">
                                    <p>{item?.competency_name}</p>
                                  </td>
                                  <td className="allcolor">
                                    <ul>
                                      {item.description?.map(
                                        (targetItem: string, index: number) => (
                                          <li key={index}>
                                            <input
                                              type="radio"
                                              name={`option-${item.id}`}
                                              id={`option-${item.id}-${index}`}
                                            />{" "}
                                            &nbsp;
                                            <label
                                              htmlFor={`option-${item.id}-${index}`}
                                            >
                                              {targetItem}
                                            </label>
                                          </li>
                                        ),
                                      )}
                                    </ul>
                                  </td>

                                  {/* <td>{item.weightage}</td> */}
                                  <td className="allcolor">
                                    <select
                                      className="form-select"
                                      value={item.self_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingBehaiviroul.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolor">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item.self_achievement}
                                      readOnly
                                    />
                                  </td>
                                  <td className="allcolor">
                                    <select
                                      className="form-select"
                                      value={item?.manager_rating || ""}
                                      disabled={item.status === "M_APPROVED"}
                                      onChange={(e: any) => {
                                        handleKraChange(
                                          idx,
                                          "manager_rating",
                                          e.target.value,
                                        );
                                      }}
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingBehaiviroul.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolor">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item?.manager_comments}
                                      readOnly={item.status === "M_APPROVED"}
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "manager_comments",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </td>

                                  <td>
                                    <select
                                      className="form-select"
                                      value={item?.manager_rating || ""}
                                      disabled={item.status === "M_APPROVED"}
                                      onChange={(e: any) => {
                                        handleKraChange(
                                          idx,
                                          "manager_rating",
                                          e.target.value,
                                        );
                                      }}
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingBehaiviroul.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td>
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item?.manager_comments}
                                      readOnly={item.status === "M_APPROVED"}
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "manager_comments",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {behaDetailsData &&
                    behaDetailsData.length > 0 &&
                    behaDetailsData[0].status === "M_APPROVED" ? (
                      <div className="p-2 d-flex gap-2 justify-content-end">
                        <p className="text-danger fw-bold">
                          You have successfully submitted your Performance.
                          Please note that you will not be able to make any
                          further changes.
                        </p>
                      </div>
                    ) : (
                      <div className="p-2 d-flex gap-2 justify-content-end ">
                        <div>
                          <button
                            className="btn btn-primary tab-button"
                            onClick={(e: any) => {
                              BhaviorSaveDraft(e, "M_DRAFT");
                            }}
                          >
                            Save as draft
                          </button>
                        </div>
                        {/* <div>
                    <button className="btn btn-outline-secondary">Submit</button>
                  </div> */}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : activetab === "Potential" ? (
              <>
                <div className="custom-table-wrapper">
                  <div className="custom-table-responsive">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>SNo</th>
                          <th>Potential</th>
                          <th>Description</th>
                          <th>Employee Rating</th>
                          <th>Employee Comments</th>
                          <th>Manager Rating</th>
                          <th>Manager Comments</th>
                          <th>Skip Manager Rating</th>
                          <th>Skip Manager Comments</th>
                          {/* <th>HOD Rating</th>
                            <th>HOD Comments</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {potentialData.map((item: any, catIdx: number) =>
                          item.subcategories.map(
                            (subItem: any, subIdx: number) => {
                              const showSNo = subIdx === 0;
                              const showCategory = subIdx === 0;
                              const rowSpanCount = item.subcategories.length;

                              return (
                                <tr key={`row-${catIdx}-${subIdx}`}>
                                  {showSNo ? (
                                    <td
                                      rowSpan={rowSpanCount}
                                      className="allcolor"
                                    >
                                      {catIdx + 1}
                                    </td>
                                  ) : null}
                                  {showCategory ? (
                                    <td
                                      rowSpan={rowSpanCount}
                                      className="allcolor"
                                    >
                                      {item.category}
                                    </td>
                                  ) : null}
                                  <td className="allcolor">
                                    {subItem.subcategory}
                                  </td>
                                  <td className="allcoloremployee">
                                    <select
                                      className="form-select"
                                      value={subItem.employee_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcoloremployee">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea allcoloremployee"
                                      value={subItem.employee_achievement}
                                      readOnly
                                    />
                                  </td>
                                  <td className="allcolormanager">
                                    <select
                                      className="form-select"
                                      value={subItem?.r1_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolormanager">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea allcolormanager"
                                      value={subItem?.r1_achievement}
                                      readOnly
                                    />
                                  </td>
                                  <td className="allcolorskipmanager">
                                    <select
                                      className="form-select"
                                      value={subItem?.r2_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolorskipmanager">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea-skipmanager allcolorskipmanager"
                                      value={subItem?.r2_achievement}
                                      readOnly
                                    />
                                  </td>{" "}
                                  {/* <td>
                                      <select
                                        className="form-select"
                                        value={subItem?.rating || ""}
                                        disabled={getPMSStatusManager?.data?.status === "Submit"}
                                        onChange={(e: any) => {
                                          handlePotensialChange(
                                            catIdx,
                                            subIdx,
                                            "rating",
                                            e.target.value,
                                          );
                                        }}
                                      >
                                        <option value="">Select Rating</option>
                                        {ratingOptions.map(
                                          (option: any, index: any) => (
                                            <option
                                              key={index}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </td>
                                    <td>
                                      <textarea
                                        rows={2}
                                        className="custom-textarea"
                                        value={subItem?.achievement}
                                        readOnly={getPMSStatusManager?.data?.status === "Submit"}
                                        onChange={(e) => {
                                          handlePotensialChange(
                                            catIdx,
                                            subIdx,
                                            "achievement",
                                            e.target.value,
                                          );
                                        }}
                                      />
                                    </td>{" "} */}
                                </tr>
                              );
                            },
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="p-2 d-flex gap-2 justify-content-end ">
                    <div>
                      <button
                        className="btn btn-primary tab-button"
                        onClick={() => setActivetab("Overall Comments")}
                      >
                        Next
                      </button>
                    </div>
                    {/* {getPMSStatusManager?.data?.status === "Submit" ? null :
                        <div>
                          <button
                            className="btn btn-primary tab-button"
                            onClick={(e: any) => {
                              PotensialSaveDraft(e);
                            }}
                          >
                            Save as draft
                          </button>
                        </div>
                      } */}
                  </div>
                </div>
              </>
            ) : (
              <>
                <table className="overall-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>KRA Rating</th>
                      <th>Potential Rating</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* <tr>
                          <td>HOD</td>
                          <td>{managerRatingData?.KRA.hod_managerRating.toFixed(2)}</td>
                          <td>{managerRatingData?.Potential.hod_managerRating.toFixed(2)}</td>
                        </tr> */}
                    <tr>
                      <td>Skip Manager Manager</td>
                      <td>
                        {managerRatingData?.KRA.skip_managerRating.toFixed(2)}
                      </td>
                      <td>
                        {managerRatingData?.Potential.skip_managerRating.toFixed(
                          2,
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Manager</td>
                      <td>{managerRatingData?.KRA.managerRating.toFixed(2)}</td>
                      <td>
                        {managerRatingData?.Potential.managerRating.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>Employee</td>
                      <td>{managerRatingData?.KRA.selfRating.toFixed(2)}</td>
                      <td>
                        {managerRatingData?.Potential.selfRating.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="row p-2 mt-2">
                  <div className="col-md-6 mb-3">
                    <h5 className="fw-semibold mb-1">
                      Employee Career Aspirations
                    </h5>
                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Enter manager's comments here..."
                      value={comaspiDetailsData?.employee_carrier_aspiration}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <h5 className="fw-semibold mb-1">
                      Employee Overall Comments
                    </h5>
                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Enter employee's comments here..."
                      readOnly
                      value={comaspiDetailsData?.employee_comments}
                    />
                  </div>
                </div>
                <div className="row p-2">
                  <div className="col-md-6 mb-3">
                    <h5 className="fw-semibold mb-1">
                      Manager Career Aspirations
                    </h5>
                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Enter manager's comments here..."
                      value={comaspiDetailsData?.manager_carrier_aspiration}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <h5 className="fw-semibold mb-1">
                      Manager Overall Comments
                    </h5>
                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Enter employee's comments here..."
                      readOnly
                      value={comaspiDetailsData?.R1_comments}
                    />
                  </div>
                </div>
                <div className="row p-2">
                  <div className="col-md-6 mb-3">
                    <h5 className="fw-semibold mb-1">
                      Skip Manager Career Aspirations
                    </h5>
                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Enter career aspirations here..."
                      name="skip_manager_carrier_aspiration"
                      value={
                        comaspiDetailsData?.skip_manager_carrier_aspiration
                      }
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <h5 className="fw-semibold mb-1">
                      Skip Manager Overall Comments
                    </h5>
                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Enter comments here..."
                      name="R2_comments"
                      value={comaspiDetailsData?.R2_comments}
                      readOnly
                    />
                  </div>
                </div>
              </>
            )}
          </section>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Annual Review [Career Aspirations]
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              {/* Manager's Comments */}
              <div className="bg-dark p-2 text-light">
                <h6 className="text-light">R1 Manager's Comments</h6>
              </div>
              <div className="mt-2 mb-4">
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Enter manager's career aspirations comments..."
                  name="manager_carrier_aspiration"
                  value={comaspiDetailsData?.manager_carrier_aspiration}
                  readOnly
                />
              </div>

              {/* Employee's Comments */}
              <div className="bg-dark p-2 text-light">
                <h6 className="text-light">Employee's Comments</h6>
              </div>
              <div className="mt-2">
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Enter employee's career aspirations comments..."
                  readOnly
                  value={comaspiDetailsData?.employee_carrier_aspiration}
                />
              </div>

              <div className="d-flex mt-4 mb-4 gap-2 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="ratinginfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Ratings & Calculation of your score
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  This year we are using a 5 point rating scale. The value
                  assigned to each rating is as below.
                </h5>
              </div>

              {/* Dynamic Ratings Table */}
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Code</th>
                    <th>Scale</th>
                  </tr>
                </thead>
                <tbody>
                  {ratingData && ratingData.length > 0 ? (
                    [...ratingData]
                      .reverse()
                      .map((item: any, index: number) => (
                        <tr key={index}>
                          <td>{item.rating}</td>
                          <td>{item.name}</td>
                          <td>{item.code}</td>
                          <td>{item.scale}</td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No rating data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="mt-3">
                <p>
                  Your score is determined entirely by your score on your
                  KRA/KPI OR a composite where the weight of the KRA is 80%,
                  Potential is 20%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PmsReviewHod;
